/* tslint:disable */
/* eslint-disable */
/* @relayHash c0273fa7d5dab4b30bc10ef456cac226 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AuditsFilter = {
    auditTemplateUUIDs?: Array<string> | null;
    searchText?: string | null;
};
export type Page = {
    offset?: number | null;
    limit?: number | null;
};
export type App_Audits_QueryVariables = {
    filter?: AuditsFilter | null;
    page?: Page | null;
};
export type App_Audits_QueryResponse = {
    readonly audits: {
        readonly " $fragmentRefs": FragmentRefs<"Audits_audits">;
    };
    readonly auditTemplates: {
        readonly " $fragmentRefs": FragmentRefs<"Audits_auditTemplates">;
    } | null;
};
export type App_Audits_Query = {
    readonly response: App_Audits_QueryResponse;
    readonly variables: App_Audits_QueryVariables;
};



/*
query App_Audits_Query(
  $filter: AuditsFilter
  $page: Page
) {
  audits(filter: $filter, page: $page) {
    ...Audits_audits
  }
  auditTemplates {
    ...Audits_auditTemplates
  }
}

fragment Audits_auditTemplates on AuditTemplatePage {
  edges {
    uuid
    name
    auditType
  }
  pageInfo {
    total
    offset
    limit
    given
  }
}

fragment Audits_audits on AuditPage {
  edges {
    uuid
    auditSent
    auditTemplate {
      name
      uuid
    }
    auditor {
      firstName
      lastName
    }
    pdfUrl
  }
  pageInfo {
    total
    offset
    limit
    given
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "filter",
            "type": "AuditsFilter",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "page",
            "type": "Page",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        } as any),
        ({
            "kind": "Variable",
            "name": "page",
            "variableName": "page"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "uuid",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "total",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "offset",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "limit",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "given",
                "args": null,
                "storageKey": null
            }
        ]
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "App_Audits_Query",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "audits",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "AuditPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "Audits_audits",
                            "args": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "auditTemplates",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "AuditTemplatePage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "Audits_auditTemplates",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "App_Audits_Query",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "audits",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "AuditPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Audit",
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "auditSent",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "auditTemplate",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "AuditTemplate",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/),
                                        (v2 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "auditor",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Admin",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "firstName",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "lastName",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "pdfUrl",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        (v4 /*: any*/)
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "auditTemplates",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "AuditTemplatePage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "AuditTemplate",
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "auditType",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        (v4 /*: any*/)
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "App_Audits_Query",
            "id": null,
            "text": "query App_Audits_Query(\n  $filter: AuditsFilter\n  $page: Page\n) {\n  audits(filter: $filter, page: $page) {\n    ...Audits_audits\n  }\n  auditTemplates {\n    ...Audits_auditTemplates\n  }\n}\n\nfragment Audits_auditTemplates on AuditTemplatePage {\n  edges {\n    uuid\n    name\n    auditType\n  }\n  pageInfo {\n    total\n    offset\n    limit\n    given\n  }\n}\n\nfragment Audits_audits on AuditPage {\n  edges {\n    uuid\n    auditSent\n    auditTemplate {\n      name\n      uuid\n    }\n    auditor {\n      firstName\n      lastName\n    }\n    pdfUrl\n  }\n  pageInfo {\n    total\n    offset\n    limit\n    given\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '4b2294e1cb95cc8372ddce86f9594c3d';
export default node;
